import { gql } from '@apollo/client';

export const GET_PRELOADER_ACTIONS_IN_PROGRESS = gql`
  query GetPreloaderActionsInProgress {
    preloader @client {
      actionsInProgressAmount
    }
  }
`;
